// Variable zum Speichern des Übergangsstatus
var transitionDone = true;
// Funktion zum Ändern des Logos
function changeLogo() {
    var logo = document.getElementById("logo");
    var logoImg1 = document.getElementById("logoImg1");
    var logoImg2 = document.getElementById("logoImg2");
    var scrollPosition = window.scrollY;
    if (logo == null) return;
    if (logoImg1 == null) return;
    if (logoImg2 == null) return;
    if (scrollPosition > 400 && !transitionDone) {
        logo.classList.replace("logo", "logo2");
        logoImg1.classList.add("has-opacity-0");
        logoImg2.classList.add("has-opacity-0");
        setTimeout(function() {
            if (logo == null) return;
            if (logoImg1 == null) return;
            if (logoImg2 == null) return;
            logoImg1.classList.add("is-hidden");
            logoImg2.classList.remove("is-hidden");
            logoImg1.classList.remove("has-opacity-0");
            logoImg2.classList.remove("has-opacity-0");
        }, 200);
        transitionDone = true;
    } else if (scrollPosition <= 400 && transitionDone) {
        logo.classList.replace("logo2", "logo");
        logoImg1.classList.add("has-opacity-0");
        logoImg2.classList.add("has-opacity-0");
        setTimeout(function() {
            if (logo == null) return;
            if (logoImg1 == null) return;
            if (logoImg2 == null) return;
            logoImg1.classList.remove("is-hidden");
            logoImg2.classList.add("is-hidden");
            logoImg1.classList.remove("has-opacity-0");
            logoImg2.classList.remove("has-opacity-0");
        }, 200);
        transitionDone = false;
    }
}
// Event-Listener für das Scroll-Event
window.addEventListener("scroll", changeLogo);
// Event-Listener für das Formular
document.addEventListener("DOMContentLoaded", function() {
    changeLogo();
    const blocks = document.querySelectorAll(".block");
    function fadeInBlocks() {
        if (window.innerWidth < 700) // Entferne die Klasse 'visibleblock' und füge 'block' hinzu, um den Effekt zu deaktivieren
        blocks.forEach((block)=>{
            block.classList.replace("visibleblock", "block");
        });
        else blocks.forEach((block)=>{
            if (isElementInViewport(block)) block.classList.replace("block", "visibleblock");
        });
    }
    function isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    }
    // Direktes Auslösen der Animation für den ersten Block
    const firstBlock = document.querySelector(".firstblock");
    if (firstBlock) firstBlock.classList.replace("firstblock", "visibleblock");
    window.addEventListener("scroll", fadeInBlocks);
    window.addEventListener("resize", fadeInBlocks);
    // Initiales Auslösen der Funktion, um den Zustand bei Seitenaufruf zu prüfen
    fadeInBlocks();
});

//# sourceMappingURL=index.591c65e5.js.map
